import "moment/locale/pt-br";

import * as routes from "../../utils/contants/urls";
import * as urlsApi from "../../utils/contants/urlsApi";
import {
  buildCode,
  buildDate,
  buildErroHandleItems,
  buildPagination,
  buildTimeFromSeconds,
  buildDateStringWithHour
} from "../../helpers/sharedHelpers";
import { put, select, takeLatest } from "redux-saga/effects";

import API from "../../utils/API";
import { Types as MessageTypes } from "../ducks/messages";
import { Types } from "../ducks/candidates";
import { history } from "../../utils/routes";
import { kindStages } from "../../locale/index";
import moment from "moment";

moment.locale("pt-BR");

function requestCandidadetsList(params, pagina) {
  return API.put(
    `${urlsApi.VANCANCY_CANDIDATES}?NumeroPagina=${pagina}`,
    params
  )
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

function* getVacanciesToCandidates({ filter }) {
  try {
    const body = {
      codigo: filter?.code,
      idArea: (filter && filter.area) || undefined,
      idCargo: (filter && filter.job) || undefined,
      criadoEmDataInicio: (filter && filter.dateStart) || undefined,
      criadoEmDataFinal: (filter && filter.dateEnd) || undefined,
      idUsuarioQueCriou: (filter && filter.createdBy) || undefined,
      idGestor: (filter && filter.manager) || undefined,
      status: (filter && filter.status) || undefined,
      idSite: (filter && filter.site) || undefined
    };
    const { lista, paginacao } = yield requestCandidadetsList(
      body,
      (filter && filter.NumeroPagina) || 1
    );
    const stateVacanciesList = yield select(getStateVacanciesList);
    const vacancies = lista.map(vacancy => ({
      id: vacancy.id,
      code: buildCode(vacancy.dataCriacao, "VA", vacancy.id),
      job: vacancy.cargo,
      area: vacancy.area,
      manager: vacancy.gestor,
      status: vacancy.status,
      createdBy: vacancy.usuarioQueCriou,
      createdAt: moment(vacancy.dataCriacao).format("L")
    }));
    const pagination = buildPagination(
      paginacao,
      filter,
      vacancies,
      stateVacanciesList
    );
    yield put({
      type: Types.VACANCY_CANDIDATES_REQUEST_SUCCESS,
      vacancies,
      pagination,
      isLoading: false
    });
  } catch (error) {
    const errors = buildErroHandleItems(error.response);
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages: errors });
    yield put({ type: Types.VACANCY_CANDIDATES_REQUEST_FAIL, error });
  }
}

function requestCandidadetsFromVacancyList(body) {
  return API.put(
    `${urlsApi.CANDIDATES_FROM_VANCANCY}?NumeroPagina=${body.page}`,
    body
  )
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

const filterCandidates = payload => {
  const body = {
    idVaga: payload.vacancyId,
    idEtapa: payload.stageId,
    codigo: payload.code,
    cpfs: payload.cpfList,
    matriculas: payload.enrollmentList,
    idCandidato: payload.candidateId,
    nome: payload.name,
    aplicouEmDataInicial: payload.applyStartDate != null ? buildDate(payload.applyStartDate) : null,
    aplicouEmDataFinal: payload.applyEndDate != null ? buildDate(payload.applyEndDate) : null,
    dataAgendamento: payload.schedulingDate != null ? buildDate(payload.schedulingDate) : null,
    resultadoMinimo: payload.minimumResult != null ? parseInt(payload.minimumResult.replace("%", "")) / 100 : null,
    status: payload.kindCandidate,
    statusEtapa: payload.stageStatus,
    page: payload.page,
    EmBancoTalentos: payload.inBankOfTalent,
    agendamentos: payload.schedules
  };

  return body;
};

function* getCandidatesFromVacancy({ payload }) {
  try {
    const actualPage = payload && payload.firstPage ? 1 : yield select(getActualPage);
    const nextPage = actualPage + 1;
    const stateCandidatesList = yield select(getStateCandidatesList);

    const {
      candidatos,
      totalCandidatos,
      totalCandidatosAprovados,
      totalCandidatosEmProcessoAndamento,
      totalCandidatosReprovados,
      totalCandidatosBancoTalentos,
      totalCandidatosRemovidos,
      totalAgendamentos,
      vagasDisponiveis,
      nomeCargo,
      etapas,
      etapaSelecionada
    } = yield requestCandidadetsFromVacancyList(filterCandidates(payload));

    const candidates = candidatos.listaCandidatos.map(candidate => {
      return {
        id: candidate.id,
        code: buildCode(candidate.dataCriacao, "CA", candidate.id),
        name: candidate.nome,
        urlAvatar: candidate.urlAvatar,
        currentStage: candidate.etapa,
        result: candidate.result ? `${candidate.resultado}%` : " - ",
        resultStatus: candidate.status,
        status: candidate.status,
        applyedAt: moment(candidate.aplicouEm).format("L"),
        bankofTalents: candidate.emBancoTalentos,
        cpf: candidate.cpf,
        enrollment: candidate.matricula ? candidate.matricula : " - ",
        scheduled: candidate.possuiAgendamento,
        scheduleTime: candidate.horaDataAgendamento ? candidate.horaDataAgendamento : " - ",
        hourStart: candidate.horaInicioAgendamento,
        hourEnd: candidate.horaFimAgendamento,
        date: candidate.dataAgendamento,
        placeOfInterview: candidate.localAgendado,
        note: candidate.observacao
      };
    });

    const stages = etapas.map(e => ({
      id: e.id,
      name: `${e.nome}`,
      date: e.dataCriacao,
      createdBy: e.usuarioQueCriou,
      type: e.tipoEtapa
    }));

    const selectedStageFilter = {
      id: etapaSelecionada.id,
      name: `${etapaSelecionada.nome}`,
      date: etapaSelecionada.dataCriacao,
      dateStart: etapaSelecionada.dataInicialRealizacao,
      dateEnd: etapaSelecionada.dataFinalRealizacao,
      createdBy: etapaSelecionada.usuarioQueCriou,
      type: etapaSelecionada.tipoEtapa
    };

    const vacancy = {
      candidatesNumber: candidatos.paginacao.quantidade,
      allNumberOfCandidates: totalCandidatos,
      vacancies: vagasDisponiveis || 0,
      approvedCandidates: totalCandidatosAprovados,
      candidatesInProgress: totalCandidatosEmProcessoAndamento,
      disapproved: totalCandidatosReprovados,
      schedulesQuantity: totalAgendamentos,
      bankOfTalentsCandidates: totalCandidatosBancoTalentos,
      totalCandidatesRemovedVacancy: totalCandidatosRemovidos,
      name: nomeCargo,
      stages,
      selectedStageFilter
    };
    const pagination = buildPagination(
      candidatos.paginacao,
      { NumeroPagina: nextPage },
      candidates,
      stateCandidatesList
    );

    const page = pagination.currentPage;

    let newStateCandidateList = candidates;
    const stateCandidateList = yield select(getStateCandidatesList);
    if (!payload.firstPage)
      newStateCandidateList = stateCandidateList.concat(candidates);

    const hasMore = newStateCandidateList.length < totalCandidatos;

    yield put({
      type: Types.VACANCY_CANDIDATES_REQUEST_SUCCESS,
      vacancy,
      candidates: newStateCandidateList,
      isLoading: false,
      pagination,
      page,
      hasMore
    });
  } catch (error) {
    yield put({ type: Types.CANDIDATES_FROM_FAIL, error });
  }
}

function* managerCandidatesAction({
  candidates,
  kindOfAction,
  vacancyId,
  stageId,
  stageType
}) {
  try {
    yield put({
      type: Types.CANDIDATES_MANAGER_SUCCESS,
      candidates,
      kindOfAction,
      vacancyId,
      stageId,
      stageType
    });
    switch (parseInt(kindOfAction)) {
      case 0:
        return history.push(`${routes.APPROVED_CANDIDATES}/${vacancyId}`);
      case 1:
        return history.push(`${routes.DECLINED_CANDIDATES}/${vacancyId}`);
      case 4:
        return history.push(`${routes.BANKOFTALENTS_CANDIDATES}/${vacancyId}`);
      case 5:
        return history.push(`${routes.APPROVED_CANDIDATES}/${vacancyId}`);

      default:
        return history.push(`${routes.APPROVED_CANDIDATES}/${vacancyId}`);
    }
  } catch (error) {
    const errors = buildErroHandleItems(error.response);
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages: errors });
    yield put({ type: Types.VACANCY_CANDIDATES_REQUEST_FAIL, error });
  }
}

function requestCandidateActions(body) {
  return API.post(`${urlsApi.CANDIDATES_ACTION}`, body)
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

function* managerDispatchCandidatesAction({
  candidates,
  kindOfAction,
  vacancyId,
  enabledSendToCandidates,
  feedback,
  stageId
}) {
  try {
    const body = {
      acaoCandidato: kindOfAction,
      candidatos: candidates.map(e => e.id),
      feedback,
      permitirResposta: enabledSendToCandidates,
      idVaga: vacancyId,
      idEtapa: stageId
    };
    yield requestCandidateActions(body);
    history.push(`${routes.VACANCY_CANDIDATES}/${vacancyId}`);
  } catch (error) {
    const errors = buildErroHandleItems(error.response);
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages: errors });
    yield put({ type: Types.CANDIDATES_DISPATCH_MANAGER_FAIL, errors });
    history.push(`${routes.VACANCY_CANDIDATES}/${vacancyId}`);
  }
}
function getCandidate(candidateId, vacancyId) {
  return API.get(`${urlsApi.CANDIDATE_SHOW}/${candidateId}?IdVaga=${vacancyId}`)
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}
function* requestCandidate({ candidateId, vacancyId }) {
  try {
    const response = yield getCandidate(candidateId, vacancyId);
    const candidate = {
      id: response.idCandidato,
      code: buildCode(response.dataCriacaoVaga, "CA", response.idCandidato),
      name: response.candidato.nome,
      birthday: moment(response.candidato.dataNascimento).format("L"),
      rg: response.candidato.rg,
      phone1: response.candidato.telefone1,
      phone2: response.candidato.telefone2,
      cpf: response.candidato.cpf,
      email: response.candidato.email,
      job: response.cargo.funcao,
      area: response.cargo.area.descricao,
      manager: response.gestor,
      stageStatus: response.etapa,
      vacancyId: buildCode(response.dataCriacaoVaga, "VA", vacancyId),
      address: {
        neighborhood: response.candidato.endereco.bairro,
        zipCode: response.candidato.endereco.cep,
        city: response.candidato.endereco.cidade,
        attachment: response.candidato.endereco.complemento,
        state: response.candidato.endereco.estado,
        street: response.candidato.endereco.logradouro,
        nationality: response.candidato.nacionalidade.nome,
        number: response.candidato.endereco.numero
      },
      stages: response.etapas.map(e => ({
        id: e.id,
        avaliation: e.avaliacao,
        createdAt: e.dataCriacao,
        description: e.descricao,
        levelTest: e.nivelTeste,
        name: e.nome,
        porcRightQuestions: e.porcentagemAcerto,
        howManyRightQuestions: e.quantidadeAcertos,
        howManyQuestions: e.quantidadePerguntas,
        finalDate: e.realizacaoDataFinal,
        startDate: moment(e.realizacaoDataInicial).format("L"),
        status: e.status,
        spendTimeInSeconds: buildTimeFromSeconds(e.tempoGastoTesteSegundos),
        spendQuestionsInSeconds: e.tempoPerguntasSegundos,
        timeTest: e.tempoTesteSegundos,
        kindStage: e.tipoEtapa,
        kindTest: e.tipoTeste,
        createdBy: e.usuarioQueCriou
      }))
    };
    yield put({
      type: Types.CANDIDATE_SHOW_SUCCESS,
      candidate,
      isLoading: false
    });
  } catch (error) {
    const errors = buildErroHandleItems(error.response);
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages: errors });
    yield put({ type: Types.CANDIDATE_SHOW_FAIL, error });
  }
}
function* requestSaveScheduleInterview({
  candidates,
  kindOfAction,
  vacancyId,
  stageId
}) {
  try {
    const body = {
      IdVaga: vacancyId,
      idEtapa: stageId,
      acaoCandidato: kindOfAction,
      feedback: "",
      candidatos: candidates.map(e => e.id),
      agendamento: candidates.map(candidate => ({
        idCandidato: candidate.id,
        dataHorarioInicial: buildDateStringWithHour(candidate.date, candidate.hourStart),
        dataHorarioFinal: buildDateStringWithHour(candidate.date, candidate.hourEnd),
        idLocal: candidate.placeOfInterview,
        observacao: candidate.note
      })),
    };
    yield requestCandidateActions(body, vacancyId);
  } catch (error) {
    const errors = buildErroHandleItems(error.response);
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages: errors });
    yield put({ type: Types.CANDIDATES_SCHEDULE_ENTERVIEW_FAIL, error });
  }
}

function requestExportCandidates(body) {
  return API.put(`${urlsApi.EXPORT_CANDIDATES}`, body, {
    responseType: "blob"
  })
    .then(res => {
      const blob = new Blob([res.data], { type: "application/excel" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "dados_candidatos.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch(error => {
      throw error;
    });
}

function requestExportPersonalInformations(body) {
  console.log('body', body)
  return API.post(`${urlsApi.EXPORT_PERSONAL_INFORMATION}`, body.candidates, {
    responseType: "blob"
  })
    .then(res => {
      const blob = new Blob([res.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "dados_candidatos.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch(error => {
      throw error;
    });
}


function requestPasswordReset(body) {
  return API.post(`${urlsApi.RELEASE_PASSWORD_RESET}`, body.candidates, {
    responseType: "application/json"
  })
    .catch(error => {
      throw error;
    });
}

function requestAddCandidate(body) {
  return API.post(`${urlsApi.ADD_CANDIDATE}`, body)
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

function* exportCandidates({ candidates, vacancyId }) {
  try {
    const body = {
      ListaIdCandidatos: candidates.map(e => e.id),
      VagaId: vacancyId
    };
    yield requestExportCandidates(body);
    yield put({ type: Types.CANDIDATES_EXPORT_SUCCESS });
  } catch (error) {
    const errors = buildErroHandleItems(error.response);
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages: errors });
    yield put({ type: Types.CANDIDATES_EXPORT_FAIL, error });
  }
}

function* exportPersonalInformations( payload ) {
  try {
    yield requestExportPersonalInformations(payload);
    yield put({ type: Types.CANDIDATES_EXPORT_PERSONAL_INFORMATION_SUCCESS });
  } catch (error) {
    const errors = buildErroHandleItems(error.response);
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages: errors });
    yield put({ type: Types.CANDIDATES_EXPORT_FAIL, error });
  }
}

function* passwordReset( payload ) {
  try {
    yield requestPasswordReset(payload);
    yield put({ type: Types.CANDIDATES_PASSWORD_RESET_SUCCESS });
    const messages = [{ type: "info", message: "Sucesso ao resetar as senhas dos candidatos." }];
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION_SUCCESS, messages });
  } catch (error) {
    const errors = buildErroHandleItems(error.response);
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages: errors });
    yield put({ type: Types.CANDIDATES_PASSWORD_RESET_FAIL, error });
  }
}

function* addCandidate({ candidate, vacancyId }) {
  try {
    const body = {
      Justificativa: candidate.justification,
      VagaId: vacancyId,
      Matricula: candidate.matricula,
      Cpf: candidate.cpf
    };
    const payload ={ vacancyId: vacancyId, page: 1 };

    yield requestAddCandidate(body);
    yield getCandidatesFromVacancy({payload});
    yield put({ type: Types.CANDIDATES_ADD_CANDIDATE_SUCCESS });
  } catch (error) {
    const errors = buildErroHandleItems(error.response);
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages: errors });
    yield put({ type: Types.CANDIDATES_ADD_CANDIDATE_FAIL, error });
  }
}

const getStateVacanciesList = state => state.candidates.vacancies;
const getStateCandidatesList = state => state.candidates.candidates;
const getActualPage = state => state.candidates?.page;

export function* watcherSaga() {
  yield takeLatest(Types.VACANCY_CANDIDATES_REQUEST, getVacanciesToCandidates);
  yield takeLatest(Types.CANDIDATES_FROM_REQUEST, getCandidatesFromVacancy);
  yield takeLatest(Types.CANDIDATES_MANAGER_REQUEST, managerCandidatesAction);
  yield takeLatest(
    Types.CANDIDATES_DISPATCH_MANAGER_REQUEST,
    managerDispatchCandidatesAction
  );
  yield takeLatest(Types.CANDIDATE_SHOW_REQUEST, requestCandidate);
  yield takeLatest(
    Types.CANDIDATES_SCHEDULE_ENTERVIEW_REQUEST,
    requestSaveScheduleInterview
  );
  yield takeLatest(Types.CANDIDATES_EXPORT_REQUEST, exportCandidates);
  yield takeLatest(Types.CANDIDATES_ADD_CANDIDATE_REQUEST, addCandidate);

  yield takeLatest(Types.CANDIDATES_EXPORT_PERSONAL_INFORMATION_REQUEST, exportPersonalInformations);

  yield takeLatest(Types.CANDIDATES_PASSWORD_RESET_REQUEST, passwordReset);

}
